import { type AuthObject } from './types'

export function getAuthorization(authObject: AuthObject): string {
  return `${authObject.tokenType} ${authObject.accessToken}`
}
